import { createFileRoute, Link } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { Plus, Loader2 } from "lucide-react";
import { adminCouponsQuery } from "@/lib/admin/coupons.functions";
import { formatBRL } from "@/lib/format";

export const Route = createFileRoute("/admin/cupons/")({
  component: AdminCouponsList,
});

function AdminCouponsList() {
  const { data: coupons, isLoading } = useQuery(adminCouponsQuery());

  return (
    <div>
      <div className="mb-6 flex items-center justify-between">
        <h1 className="font-display text-2xl font-bold text-eg-dark">Cupons</h1>
        <Link
          to="/admin/cupons/novo"
          className="inline-flex items-center gap-2 rounded-md bg-eg-gold px-4 py-2 text-sm font-semibold text-eg-dark hover:bg-eg-goldhover transition-colors"
        >
          <Plus className="h-4 w-4" />
          Novo cupom
        </Link>
      </div>

      {isLoading && (
        <div className="flex justify-center py-12">
          <Loader2 className="h-6 w-6 animate-spin text-eg-gold" />
        </div>
      )}

      <div className="overflow-x-auto rounded-lg border border-border bg-white">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-border text-left text-xs uppercase text-muted-foreground">
              <th className="px-4 py-3">Código</th>
              <th className="px-4 py-3">Desconto</th>
              <th className="px-4 py-3">Usos</th>
              <th className="px-4 py-3">Validade</th>
              <th className="px-4 py-3">Status</th>
            </tr>
          </thead>
          <tbody>
            {coupons?.map((coupon) => (
              <tr key={coupon.id} className="border-b border-border last:border-0">
                <td className="px-4 py-3">
                  <Link
                    to="/admin/cupons/$id"
                    params={{ id: coupon.id }}
                    className="font-mono font-semibold text-eg-dark hover:text-eg-goldtext"
                  >
                    {coupon.code}
                  </Link>
                </td>
                <td className="px-4 py-3">
                  {coupon.discount_type === "percentage"
                    ? `${coupon.discount_value}%`
                    : formatBRL(coupon.discount_value)}
                </td>
                <td className="px-4 py-3 text-muted-foreground">
                  {coupon.uses_count}
                  {coupon.max_uses != null ? ` / ${coupon.max_uses}` : ""}
                </td>
                <td className="px-4 py-3 text-muted-foreground">
                  {coupon.valid_until
                    ? new Date(coupon.valid_until).toLocaleDateString("pt-BR")
                    : "Sem expiração"}
                </td>
                <td className="px-4 py-3">
                  <span
                    className={`rounded-full px-2 py-1 text-xs font-semibold ${
                      coupon.is_active
                        ? "bg-green-100 text-green-700"
                        : "bg-muted text-muted-foreground"
                    }`}
                  >
                    {coupon.is_active ? "Ativo" : "Inativo"}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {!isLoading && coupons?.length === 0 && (
          <p className="p-6 text-center text-sm text-muted-foreground">Nenhum cupom cadastrado.</p>
        )}
      </div>
    </div>
  );
}
